module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Zahtevi za godišnji")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "90%",
      "border-radius": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pretraga",
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "grid-container-admin"
  }, _vm._l((_vm.dates), function(item) {
    return _c('div', [_c('span', {
      staticStyle: {
        "display": "inline-block",
        "color": "white",
        "border-radius": "5px",
        "border-style": "solid",
        "width": "100px"
      }
    }, [_vm._v("\n                    " + _vm._s(item) + "\n                    Slobodni kurir:\n                    "), ((_vm.getNumberOfCouriersByDate(item) + _vm.getNumberForDate(item)) > 0) ? _c('i', {
      staticStyle: {
        "color": "greenyellow"
      }
    }, [_vm._v(_vm._s(_vm.getNumberOfCouriersByDate(item) + _vm.getNumberForDate(item)))]) : _vm._e(), _vm._v(" "), ((_vm.getNumberOfCouriersByDate(item) + _vm.getNumberForDate(item)) === 0) ? _c('i', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.getNumberOfCouriersByDate(item) + _vm.getNumberForDate(item)))]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredVacations), function(vacation) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', [_vm._v(_vm._s(vacation.courier.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vacation.courier.lastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(vacation.date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getDisplayStatus(vacation.status)) + " "), (vacation.status === 'APPROVED') ? _c('i', {
      staticClass: "ti-check",
      staticStyle: {
        "color": "greenyellow"
      }
    }) : _vm._e(), _vm._v(" "), (vacation.status === 'REJECTED') ? _c('i', {
      staticClass: "ti-close",
      staticStyle: {
        "color": "red"
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(vacation.notes))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [(vacation.status === 'REQUESTED') ? _c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Odobri",
        "name": "Odobri",
        "value": "Odobri"
      },
      on: {
        "click": function($event) {
          return _vm.approveVacations(vacation)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [(vacation.status === 'REQUESTED') ? _c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#843534"
      },
      attrs: {
        "type": "button",
        "placeholder": "Odbij",
        "name": "Odbij",
        "value": "Odbij"
      },
      on: {
        "click": function($event) {
          return _vm.openDeclineVacationModal(vacation)
        }
      }
    }) : _vm._e()])])
  }), 0)])])])]), _vm._v(" "), _c('decline-vacation', {
    attrs: {
      "show": _vm.openDeclineVacation,
      "vacation": _vm.vacationToEdit
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Ime")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Nadimak")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Datum za godišnji")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "150px",
      "color": "white"
    }
  }, [_vm._v("Odobri")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "150px",
      "color": "white"
    }
  }, [_vm._v("Odbij")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eca0b9d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Schedule/DriversVacations.vue
// module id = 516
// module chunks = 1